import { Directive, HostListener, Input, Optional, Self } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Directive({
  selector: '[appEnterToSave]'
})
export class EnterToSaveDirective {
  @Input('appEnterToSave') saveValue: any;

  constructor(
    @Optional() private dialogRef: MatDialogRef<unknown>,
    @Optional() @Self() private form: NgForm
  ) {}

  @HostListener('keydown.enter', ['$event'])
  onEnterKey(event: KeyboardEvent): void {
    if (!(event.target instanceof HTMLInputElement)) return;
    if (!this.form?.valid) return;
    event.preventDefault();
    this.dialogRef?.close(this.saveValue);
  }
}
